// extracted by mini-css-extract-plugin
export default {"container":"UP-z","modal":"VP-z","dimensions":"WP-z","brandName":"XP-z","productName":"YP-z","labelValue":"ZP-z","recipientEmail":"_P-z","recommendedFit":"aQ-z","hiddenField":"bQ-z"};